import React from 'react';
import one from '../assets/1.png';

const SideNav = (props) => {
    return(
        <ul className="list-group list-group-flush d-none d-md-block d-sm-block d-sm-none">
            <ul className="list-group" style={{fontSize:'20px',lineHeight:'200%',color:'#444'}}>

                <li className={`list-group-item ${props.area == 'introduction' ? 'active' : ''}`} >
                    <a className="btn-floating btn-fb btn-sm" style={{color:'inherit'}} href="/introduction">&rArr; <span style={{fontSize:'18px'}}>Introduction</span></a>
                </li>
                <li className={`list-group-item ${props.area == 'guidelines' ? 'active' : ''}`}  >
                    <a className="btn-floating btn-fb btn-sm" style={{color:'inherit'}} href="/guidelines">&rArr; <span style={{fontSize:'18px'}}>Guidelines</span></a>
                </li>
                <li className={`list-group-item ${props.area == 'faq' ? 'active' : ''}`}  >
                    <a className="btn-floating btn-fb btn-sm" style={{color:'inherit'}} href="/faq">&rArr; <span style={{fontSize:'18px'}}>FAQs</span></a>
                </li>
                <li className={`list-group-item ${props.area == 'exclusion' ? 'active' : ''}`}  >
                    <a className="btn-floating btn-fb btn-sm" style={{color:'inherit'}} href="/exclusion">&rArr; <span style={{fontSize:'18px'}}>Exclusion List</span></a>
                </li>
            </ul>
        </ul>
    );
}

export default SideNav;